var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1686_4034",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1686_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9.33333,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1686_4034)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66634 1.99998C2.66634 2.36817 2.36786 2.66665 1.99967 2.66665C1.63148 2.66665 1.33301 2.36817 1.33301 1.99998C1.33301 1.63179 1.63148 1.33331 1.99967 1.33331C2.36786 1.33331 2.66634 1.63179 2.66634 1.99998ZM5.33301 1.99998C5.33301 2.36817 5.03453 2.66665 4.66634 2.66665C4.29815 2.66665 3.99967 2.36817 3.99967 1.99998C3.99967 1.63179 4.29815 1.33331 4.66634 1.33331C5.03453 1.33331 5.33301 1.63179 5.33301 1.99998ZM7.33301 2.66665C7.7012 2.66665 7.99967 2.36817 7.99967 1.99998C7.99967 1.63179 7.7012 1.33331 7.33301 1.33331C6.96482 1.33331 6.66634 1.63179 6.66634 1.99998C6.66634 2.36817 6.96482 2.66665 7.33301 2.66665ZM10.6663 1.99998C10.6663 2.36817 10.3679 2.66665 9.99967 2.66665C9.63148 2.66665 9.33301 2.36817 9.33301 1.99998C9.33301 1.63179 9.63148 1.33331 9.99967 1.33331C10.3679 1.33331 10.6663 1.63179 10.6663 1.99998ZM3.33301 3.99998C3.7012 3.99998 3.99967 3.7015 3.99967 3.33331C3.99967 2.96512 3.7012 2.66665 3.33301 2.66665C2.96482 2.66665 2.66634 2.96512 2.66634 3.33331C2.66634 3.7015 2.96482 3.99998 3.33301 3.99998ZM6.66634 3.33331C6.66634 3.7015 6.36786 3.99998 5.99967 3.99998C5.63148 3.99998 5.33301 3.7015 5.33301 3.33331C5.33301 2.96512 5.63148 2.66665 5.99967 2.66665C6.36786 2.66665 6.66634 2.96512 6.66634 3.33331ZM8.66634 3.99998C9.03453 3.99998 9.33301 3.7015 9.33301 3.33331C9.33301 2.96512 9.03453 2.66665 8.66634 2.66665C8.29815 2.66665 7.99967 2.96512 7.99967 3.33331C7.99967 3.7015 8.29815 3.99998 8.66634 3.99998ZM10.6663 4.66665C10.6663 5.03484 10.3679 5.33331 9.99967 5.33331C9.63148 5.33331 9.33301 5.03484 9.33301 4.66665C9.33301 4.29846 9.63148 3.99998 9.99967 3.99998C10.3679 3.99998 10.6663 4.29846 10.6663 4.66665ZM7.33301 5.33331C7.7012 5.33331 7.99967 5.03484 7.99967 4.66665C7.99967 4.29846 7.7012 3.99998 7.33301 3.99998C6.96482 3.99998 6.66634 4.29846 6.66634 4.66665C6.66634 5.03484 6.96482 5.33331 7.33301 5.33331ZM5.33301 4.66665C5.33301 5.03484 5.03453 5.33331 4.66634 5.33331C4.29815 5.33331 3.99967 5.03484 3.99967 4.66665C3.99967 4.29846 4.29815 3.99998 4.66634 3.99998C5.03453 3.99998 5.33301 4.29846 5.33301 4.66665ZM1.99967 5.33331C2.36786 5.33331 2.66634 5.03484 2.66634 4.66665C2.66634 4.29846 2.36786 3.99998 1.99967 3.99998C1.63148 3.99998 1.33301 4.29846 1.33301 4.66665C1.33301 5.03484 1.63148 5.33331 1.99967 5.33331ZM3.99967 5.99998C3.99967 6.36817 3.7012 6.66665 3.33301 6.66665C2.96482 6.66665 2.66634 6.36817 2.66634 5.99998C2.66634 5.63179 2.96482 5.33331 3.33301 5.33331C3.7012 5.33331 3.99967 5.63179 3.99967 5.99998ZM5.99967 6.66665C6.36786 6.66665 6.66634 6.36817 6.66634 5.99998C6.66634 5.63179 6.36786 5.33331 5.99967 5.33331C5.63148 5.33331 5.33301 5.63179 5.33301 5.99998C5.33301 6.36817 5.63148 6.66665 5.99967 6.66665ZM9.33301 5.99998C9.33301 6.36817 9.03453 6.66665 8.66634 6.66665C8.29815 6.66665 7.99967 6.36817 7.99967 5.99998C7.99967 5.63179 8.29815 5.33331 8.66634 5.33331C9.03453 5.33331 9.33301 5.63179 9.33301 5.99998ZM9.99967 7.99998C10.3679 7.99998 10.6663 7.7015 10.6663 7.33331C10.6663 6.96512 10.3679 6.66665 9.99967 6.66665C9.63148 6.66665 9.33301 6.96512 9.33301 7.33331C9.33301 7.7015 9.63148 7.99998 9.99967 7.99998ZM7.99967 7.33331C7.99967 7.7015 7.7012 7.99998 7.33301 7.99998C6.96482 7.99998 6.66634 7.7015 6.66634 7.33331C6.66634 6.96512 6.96482 6.66665 7.33301 6.66665C7.7012 6.66665 7.99967 6.96512 7.99967 7.33331ZM4.66634 7.99998C5.03453 7.99998 5.33301 7.7015 5.33301 7.33331C5.33301 6.96512 5.03453 6.66665 4.66634 6.66665C4.29815 6.66665 3.99967 6.96512 3.99967 7.33331C3.99967 7.7015 4.29815 7.99998 4.66634 7.99998ZM2.66634 7.33331C2.66634 7.7015 2.36786 7.99998 1.99967 7.99998C1.63148 7.99998 1.33301 7.7015 1.33301 7.33331C1.33301 6.96512 1.63148 6.66665 1.99967 6.66665C2.36786 6.66665 2.66634 6.96512 2.66634 7.33331Z",
    fill: "url(#paint0_linear_1686_4034)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1686_4034",
    x: 1.33301,
    y: 1.33331,
    width: 9.33301,
    height: 7.66669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1686_4034"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1686_4034",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1686_4034",
    x1: 1.33301,
    y1: 1.33331,
    x2: 1.33301,
    y2: 7.99998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.94a0b178d53f3181981982b5b3d95643.svg";
export { ForwardRef as ReactComponent };